// extracted by mini-css-extract-plugin
export default {"PrimaryButton":"PrimaryButton_PrimaryButton__gzWcj","Disabled":"PrimaryButton_Disabled__1KK5k"};